import React from 'react'
import { YouTubeEmbed } from 'react-social-media-embed'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useSelector, useDispatch } from 'react-redux'

import { Box, Button, Chip, Grid, Divider, Typography } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { Skeleton } from '@material-ui/lab'
import { selectWhatsNewData, fetchWhatsNewArticles } from './WhatsNewPageSlice'
import WhatsNewFeedback from './components/feedbackModal/WhatsNewFeedback'
import { getImageFromFirebaseWithHook } from '../../helpers'
import CheckIsMobile from '../../../../../utils/isMobileHook'
import whatsNewPageStyles from './WhatsNewPageStyle'

const WhatsNewItemPage = (props) => {
  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch(fetchWhatsNewArticles())
  }, [])
  const history = useHistory()
  const title = props.location.pathname.split('/')[2]
  const classes = whatsNewPageStyles()
  const isMobile = CheckIsMobile()

  const whatsNewData = useSelector(selectWhatsNewData)
  const [itemdata, setItemdata] = React.useState(null)
  const [image, setImage] = React.useState('')
  const CHIPSKELETONS = ['s1', 's2', 's3']

  React.useEffect(() => {
    const article = whatsNewData?.articles?.articles?.filter(
      (item) => item.title === title,
    )

    if (article) {
      getImageFromFirebaseWithHook(article[0].image, setImage)
      setItemdata(article[0])
    }
  }, [whatsNewData])

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  function isYouTubeUrl(url) {
    const regex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/
    return regex.test(url)
  }

  return (
    <Box className={classes.itemPageLayout}>
      <Box className={classes.itemPageheader}>
        <Button
          className={classes.backButton}
          onClick={() => history.push(`/WhatsNew`)}
        >
          <ArrowBackIcon className={classes.backArrow} />
          <Typography variant="h2">Back</Typography>
        </Button>
      </Box>
      <Box className={classes.pageBody}>
        <Box className={classes.heroImageFoundation}>
          <Box className={classes.heroImageContainer}>
            {image ? (
              <img
                className={classes.heroImage}
                alt={itemdata?.imageAlt}
                src={image}
              />
            ) : (
              <div className={classes.imagePlaceholder} />
            )}
          </Box>
        </Box>
        <Grid
          container
          className={classes.subtitleContainer}
          justifyContent="space-between"
        >
          <Grid item xs={8} sm={10} className={classes.altTextContainer}>
            {image ? (
              <Typography variant="caption">{itemdata?.imageAlt}</Typography>
            ) : (
              <Skeleton width={400} variant="rect" />
            )}
          </Grid>
          <Grid item xs={4} sm={2} className={classes.feedbackContainer}>
            <WhatsNewFeedback incomingTitle={title} />
          </Grid>
        </Grid>

        <Box className={classes.textContent}>
          <Box className={classes.tagList}>
            {itemdata ? (
              itemdata?.tags.map((tag) => (
                <Chip className={classes.tagItem} key={`${tag}$`} label={tag} />
              ))
            ) : (
              <Box className={classes.skeletonWrapper}>
                {CHIPSKELETONS.map((s) => (
                  <Skeleton
                    key={s}
                    className={classes.chipSkeleton}
                    width={100}
                    height={32}
                    variant="rect"
                  />
                ))}
              </Box>
            )}
          </Box>
          <Typography variant="h1" className={classes.title}>
            {title}
          </Typography>
          <Divider className={classes.titleDivider} />
          {itemdata?.link && (
            <Box className={classes.videoContent}>
              {isYouTubeUrl(itemdata?.link) && image ? (
                <YouTubeEmbed
                  className={classes.videoPlayer}
                  width="100%"
                  height={isMobile ? 300 : 400}
                  url={itemdata?.link}
                />
              ) : null}
            </Box>
          )}
          <Typography variant="body1" style={{ marginBottom: '60px' }}>
            {itemdata?.description}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default WhatsNewItemPage
